import { render } from "./GroupsPage.vue?vue&type=template&id=c99a1092"
import script from "./GroupsPage.vue?vue&type=script&lang=js"
export * from "./GroupsPage.vue?vue&type=script&lang=js"
script.render = render

export default script